// src/modules/settings/SettingsList.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import SearchInput from '../../components/shared/SearchInput';
import Pagination from '../../components/shared/Pagination';
import SettingsTable from '../../components/settings/SettingsTable';
import { getSettings, deleteSetting } from './settingsService';
import { useNavigate } from 'react-router-dom'; 
import { FaPlus } from 'react-icons/fa';
import DashboardLayout from '../../layouts/DashboardLayout';
import Modal from '../../components/shared/Modal';  // Import the Modal component

const Container = styled.div`
  padding: 20px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AddButton = styled.button`
  background-color: ${(props) => props.theme.colors.primary};
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryDark};
  }

  svg {
    font-size: 16px;
  }
`;

const SettingsList = ({ history }) => {
  const [settingsArray, setSettingsArray] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredSettings, setFilteredSettings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [settingsPerPage] = useState(10);
  const navigate = useNavigate();  // useNavigate replaces useHistory
  const [showModal, setShowModal] = useState(false);  // Control modal visibility
  const [deleteId, setDeleteId] = useState(null);  // Store the ID of the item to delete


  useEffect(() => {

    const fetchSettings = async () => {
      const data = await getSettings();
      setSettingsArray(data);
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    setFilteredSettings(
      settingsArray.filter((setting) =>
        setting.key.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, settingsArray]);

  const indexOfLastSetting = currentPage * settingsPerPage;
  const indexOfFirstSetting = indexOfLastSetting - settingsPerPage;
  const currentSettings = filteredSettings.slice(indexOfFirstSetting, indexOfLastSetting);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleDelete = async (id) => {
    setDeleteId(id);
    setShowModal(true);
  };

  const handleConfirmDelete = async () => {
    await deleteSetting(deleteId);  // Call the delete API
    setSettingsArray(settingsArray.filter((setting) => setting.id !== deleteId));  // Update UI
    setShowModal(false);  // Close the modal
  };

  // Handle cancel in modal
  const handleCancelDelete = () => {
    setShowModal(false);  // Close the modal
  };

  return (
    <DashboardLayout>
      <Container>
        <Header>
          <h1>Settings</h1>
          <AddButton onClick={() => navigate('/settings/new')}>
            <FaPlus /> Add New Setting
          </AddButton>
        </Header>

        <SearchInput value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />

        <SettingsTable
          settings={currentSettings}
          handleEdit={(id) => navigate(`/settings/edit/${id}`)}
          handleDelete={handleDelete}  // Use handleDeleteClick to show the modal
        />

        <Pagination
          itemsPerPage={settingsPerPage}
          totalItems={filteredSettings.length}
          paginate={paginate}
          currentPage={currentPage}
        />

        {/* Show the modal when showModal is true */}
      {showModal && (
        <Modal
          message="This action can't be redone. After deleting this setting all the settings related to this register will be broken."
          title="Are you sure?"
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
        />
      )}
      </Container>
    </DashboardLayout>
  );
};

export default SettingsList;
